import Vue from 'vue'
import axios from 'axios'

import { baseURL } from '~/store/util/values'
import * as TYPE from '~/store/util/types'

import { deepCopy } from '~/store/util/util'

const state = () => ({
	locations: []
})

const mutations = {
	[TYPE.SET_ALL_LOCATIONS]: (state, payload) => {
		state.locations = payload
	},
	[TYPE.ADD_LOCATION]: (state, payload) => {
		state.locations.push(payload)
	}
}

const actions = {
	favoriteLocation({ commit, rootState }, payload) {
		axios
			.post(
				'/api/v1/location/favorite/',
				{
					location_slug: payload
				},
				{
					headers: { Accept: 'application/json' }
				}
			)
			.then(response => {
				let data = JSON.parse(response.data)
				commit(TYPE.SET_USER_PROP, {
					prop: 'liked_locations',
					value: data.liked_locations
				})
			})
			.catch(error => {
				console.error(error)
			})
	},
	serverPostLocation({ state }, payload) {
		return axios({
			method: 'post',
			url: '/api/v1/location/',
			data: payload
		})
			.then(response => {
				return response
			})
			.catch(error => {
				console.error(error)
				return error
			})
	},
	fetchAllLocations({ commit }) {
		axios
			.get('/api/v1/location/?format=json')
			.then(result => {
				commit(TYPE.SET_ALL_LOCATIONS, result.data)
			})
			.catch(error => {
				console.error(error)
			})
	},
	setAllLocations({ commit }, payload) {
		commit(TYPE.SET_ALL_LOCATIONS, payload)
	},
	addLocation({ commit }, payload) {
		commit(TYPE.ADD_LOCATION, payload)
	}
}

const getters = {
	getAllLocations: state => {
		return state.locations
	},
	getMyLocations: (state, getters) => {
		if (getters.user) {
			return state.locations.filter(l => {
				return (
					l.owner === getters.user.pk ||
					l.coowners.indexOf(getters.user.pk) > -1
				)
			})
		}
		return []
	},
	getLocation: state => locationID => {
		return state.locations.find(location => {
			return location.pk === parseInt(locationID)
		})
	},
	getLocationBySlug: state => locationSlug => {
		return state.locations.find(location => {
			return location.slug === locationSlug
		})
	},
	getLocationDistance: (state, getters) => locationID => {
		let visitorLocation = getters.getVisitorLocation
		let userLat = visitorLocation.latitude
		let userLon = visitorLocation.longitude
		let distance = 0
		let destination = null
		destination = getters.getLocation(locationID)
		let locationLat = null
		let locationLon = null

		if (destination.hasOwnProperty('address')) {
			if (destination.address.hasOwnProperty('private_latitude')) {
				locationLat = destination.address.private_latitude
				locationLon = destination.address.private_longitude
			} else if (destination.address.hasOwnProperty('public_latitude')) {
				locationLat = destination.address.public_latitude
				locationLon = destination.address.public_longitude
			} else if (destination.hasOwnProperty('private_latitude')) {
				locationLat = destination.private_latitude
				locationLon = destination.private_longitude
			} else {
				locationLat = destination.public_latitude
				locationLon = destination.public_longitude
			}
	
			let latDifference = Math.abs(locationLat - userLat)
			let lonDifference = Math.abs(locationLon - userLon)
			let latitudeLength = 69.172
			let longitudeLength =
				Math.cos(locationLat * Math.PI / 180.0) * latitudeLength
			let latMiles = latDifference * latitudeLength
			let lonMiles = lonDifference * longitudeLength
			distance = Math.round(
				Math.sqrt(Math.pow(latMiles, 2) + Math.pow(lonMiles, 2))
			)
		}
		return distance
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
